import { render, staticRenderFns } from "./BanksList.vue?vue&type=template&id=09d3f33a&scoped=true&"
import script from "./BanksList.vue?vue&type=script&lang=js&"
export * from "./BanksList.vue?vue&type=script&lang=js&"
import style0 from "./BanksList.vue?vue&type=style&index=0&id=09d3f33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d3f33a",
  null
  
)

export default component.exports